import { call } from 'redux-saga/effects';
import fetchData from './apiRequest';

export function* requestDisinfectionReport(facilityId) {
  let path = `facilities/${facilityId}/disinfection_reports`;

  return yield call(fetchData, path, { responseType: 'blob' });
}
